import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../core/auth/services/auth.service';
import { inject } from '@angular/core';
import { UserRole } from '../../core/auth/models/profile';
import { AlertService } from '../services/alert.service';

export const DataAuthorizationGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService: AuthService = inject(AuthService);
  const router = inject(Router);
  const toastService = inject(AlertService);

  const ta = route.paramMap.get('ta');

  // If no :ta parameter, redirect to home
  if (!ta) {
    router.navigate(['/']);
    return false;
  }

  const dbUserData = authService.dbUserData;

  // If no user data available, redirect to home
  if (!dbUserData) {
    router.navigate(['/']);
    return false;
  }

  //admins and leads have access to all data
  if (
    dbUserData.role === UserRole.ADMIN ||
    dbUserData.role === UserRole.LEADERSHIP_USER
  ) {
    return true;
  }

  // Check if :ta is contained in user's therapeutic_areas
  if (!dbUserData.therapeutic_areas?.includes(ta)) {
    toastService.showToast({
      message: `You do not have access to the ${ta} therapeutic area.
      please contact an administrator if you believe this is an error.`,
    });
    router.navigate(['/']);
    return false;
  }

  return true;
};
